import type {
  AvatarConfig,
  TournamentDetail,
  TournamentHistoryRow,
  TournamentPodiumEntry,
  TournamentPublic,
} from '@shared/index'
import { api } from './http'

export type TournamentCurrent = TournamentPublic & {
  lockedDeckId: string | null
}

export function fetchTournamentCurrent(token: string): Promise<TournamentCurrent> {
  return api<TournamentCurrent>('/tournaments/current', { token, quiet: true })
}

export function fetchTournamentHistory(
  token: string,
): Promise<{ tournaments: TournamentHistoryRow[]; podium: TournamentPodiumEntry[] }> {
  return api('/tournaments', { token, quiet: true })
}

export function fetchTournamentDetail(token: string, id: string): Promise<TournamentDetail> {
  return api(`/tournaments/${encodeURIComponent(id)}`, { token })
}

export function joinTournament(
  token: string,
  body: {
    deckId: string
    avatar: AvatarConfig
    matId: string
    sleeveId: string | null
  },
): Promise<{ ok: true }> {
  return api('/tournaments/join', {
    token,
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function leaveTournament(token: string): Promise<{ ok: true }> {
  return api('/tournaments/leave', { token, method: 'POST' })
}
